import { Button, Typography } from "@material-tailwind/react";
import SideBar from "../../components/sidebar.tsx/SideBar";
import { IoIosAdd } from "react-icons/io";
import BoatCard from "../../components/booking/BoatCard";
import { useNavigate } from "react-router-dom";
import { routerPaths } from "../../services/path";
import { useQuery } from "react-query";
import ApiRoutes from "../../services/apiRoutes";
import AuthService from "../../services/authService";
import api from "../../services/apiService";
import DefaultLoading from "../../components/common/DefaultLoading";
import { Fragment, useState } from "react";
import { BoatResponse } from "../../models/boat/boat";
import ErrorLoadingState from "../../components/common/buttons/ErrorLoadingState";
import { BoatService } from "../../services/boatService";
import { useAddressStore } from "../../store/boat/address";
import { useOnboardingStore } from "../../store/onboarding/Onboarding";
import { useBoatDetailsStore } from "../../store/boat/boatDetails";
import BoatEmptyState from "./BoatEmptyState";

function Boat() {
  const navigation = useNavigate();
  const partnerId = AuthService.user?.data.id;
  const [errorText, setErrorText] = useState<string | null>(null);
  const { resetAddress } = useAddressStore();
  const { clearProfileState } = useOnboardingStore();
  const { clearBoatDetails } = useBoatDetailsStore();
  const { isLoading, data } = useQuery<BoatResponse>(
    `${ApiRoutes.viewBoatsByPartnerId}${partnerId}`,
    () => api.get(`${ApiRoutes.viewBoatsByPartnerId}${partnerId}`),
    {
      onError: (error) => {
        console.log(error);
        setErrorText(error as string);
      },
    }
  );

  return (
    <div className="md:flex">
      <div className="bg-gray-100 h-full">
        <SideBar />
      </div>
      {/* main content */}
      <div className="flex-1 md:p-8">
        {isLoading ? (
          <div className="flex items-center justify-center h-screen">
            <DefaultLoading />
          </div>
        ) : errorText !== null ? (
          <Fragment>
            <div className="flex items-center justify-center h-screen">
              <ErrorLoadingState />
            </div>
          </Fragment>
        ) : data?.data.payload.data.length === 0 ? (
          <div className="flex items-center justify-center h-screen">
            <BoatEmptyState />
          </div>
        ) : (
          <Fragment>
            <div className="flex-1 p-8">
              <Typography
                placeholder={undefined}
                className="text-3xl font-semibold mb-3"
              >
                Boat
              </Typography>
              <Button
                className="flex items-center  md:my-0 gap-3 normal-case rounded-xl bg-primary "
                onClick={() => {
                  resetAddress();
                  clearProfileState();
                  clearBoatDetails();
                  BoatService.clearSavedBoat();
                  navigation(routerPaths.createBoat);
                }}
                placeholder={undefined}
              >
                <IoIosAdd size={25} />
                <Typography placeholder={undefined}>Add New Boat</Typography>
              </Button>
            </div>
            <div className="flex-1 p-8">
              <div className="md:grid grid-cols-3 gap-4">
                {data?.data.payload.data.map((boat) => {
                  const boatDate = new Date(boat.dateCreated);
                  return (
                    <BoatCard
                      id={boat.boatId}
                      key={boat.boatId}
                      isImageAdded={boat.arePicturesUploaded}
                      isPriceAdded={boat.isPriceSet}
                      name={boat.model!}
                      per="day"
                      price={boat.hourlyRate.toString()!}
                      createdDate={boatDate}
                      isActive={boat.isAvailable}
                      boat={boat}
                    />
                  );
                })}
              </div>
            </div>
          </Fragment>
        )}
      </div>
    </div>
  );
}

export default Boat;
